import React from 'react';

import { CardBody, CardHeader, CardItem, CardItemKey, CardItemValue, CardTitle, CardWrapper } from './Card.styles';
import { CardProps } from './Card.types';

export const Card = ({ children, ...props }: CardProps) => {
  return <CardWrapper {...props}>{children}</CardWrapper>;
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Title = CardTitle;
Card.Item = CardItem;
Card.ItemKey = CardItemKey;
Card.ItemValue = CardItemValue;
